import { ConceptKey } from "../../../models/concept";

// コンセプトは順番を決めておく。上からtest1、test2、現行品、競合品
export const conceptNumber = {
	test1: 1,
	test2: 2,
	// 現行品がrepで回収されることになったため、調整
	currentProduct: 3,
	benchmark: 4,
} as const satisfies { [key in ConceptKey]: number };

/**
 * Quotaのコード番号
 */
export const quotaCode = {
	// rep
	test1: "A",
	test2: "B",
	currentProduct: "C",
	// boost
	category: "D",
	strategy: "E",
	// brand user
	brandUser: "F",
} as const;

/**
 * カウント用のコード番号
 */
export const countQuotaCode = {
	general: "W",
	category: "X",
	strategy: "Y",
	brandUser: "Z",
} as const;
